import { Pin, PinOff } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { useCompareShortlist } from "@/hooks/useCompareShortlist";

/**
 * PinToCompareButton — sits in the UniversityDetail action stack
 * next to "Save to shortlist". Pins/unpins the current uni into a
 * LocalStorage compare shortlist (capped at 4) that the floating
 * bar reads.
 */
export default function PinToCompareButton({ uni }) {
  const { has, toggle, full } = useCompareShortlist();
  const pinned = has(uni.id);

  const onClick = () => {
    if (!pinned && full) {
      toast.error("Compare shortlist is full (4 max). Remove one to add.");
      return;
    }
    toggle(uni.id);
    toast.success(pinned ? "Removed from compare" : "Pinned — click Compare below to view side-by-side");
  };

  return (
    <Button
      variant={pinned ? "default" : "outline"}
      onClick={onClick}
      data-testid="pin-to-compare-btn"
      className={
        pinned
          ? "bg-[#7C3AED] hover:bg-[#6D28D9] text-white rounded-md"
          : "rounded-md border-[#7C3AED]/40 text-[#7C3AED] hover:bg-[#7C3AED]/5"
      }
    >
      {pinned
        ? <><PinOff className="h-4 w-4 mr-1.5" /> Pinned</>
        : <><Pin className="h-4 w-4 mr-1.5" /> Pin to compare</>}
    </Button>
  );
}
